import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import Log from "../classes/Log";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Log/All/RecuperarPorFiltro" },
  { method: "POST", rota: "Log/Adicionar" },
  { method: "PUT", rota: "Log/Atualizar" },
  { method: "DELETE", rota: "Log/Apagar" },
];

const cacheKey: string = "LogCache";
const cacheKeySelC: string = "LogSelecionado";

const apiServico: string = "PORTAL";

export default class LogDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(centro: string): Promise<Log[]> {
    let ok: boolean = false;
    let data: Log[] = [];
    let error: any = undefined;
    let url = `${calls[0].rota}?centro=${centro}`;
    await super
      .Get(url)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = Log.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<Log[]>((resolve) => {
      resolve(data);
    });
  }

  async add(value: Log) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[1].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async update(value: Log): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .put(calls[2].rota, Log.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  async remove(value: Log): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    await super
      .delete(calls[3].rota, Log.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): Log[] {
    let result: Log[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: Log[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
